exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".sub-title[data-v-069bc928] {\n  font-size: 18px;\n}\n.sub-wrapper[data-v-069bc928] {\n  flex-wrap: wrap;\n  justify-content: space-between;\n  width: 100%;\n}\n.sub-wrapper.items-per-row-2 > div[data-v-069bc928] {\n  max-width: 480px;\n}\n.sub-wrapper.items-per-row-3 > div[data-v-069bc928] {\n  max-width: 306px;\n}\n.sub-description[data-v-069bc928] {\n  font-size: 14px;\n}", ""]);

// exports
